import coverAsset from '../../assets/blog/covers/gitops-aks-gke.jpg';
import diagramAsset from '../../assets/blog/images/gitops-landing-zones.jpg';
import { assetUrl } from '../../utils/assetUrl';

const cover = assetUrl(coverAsset);
const diagram = assetUrl(diagramAsset);

const post = {
  slug: 'gitops-aks-gke',
  title: 'GitOps Landing Zones on AKS and GKE',
  date: '2026-08-10',
  cover,
  excerpt:
    'How Flux CD, Kustomize, and workload identity come together for a repeatable multi-cloud platform foundation.',
  tags: ['GitOps', 'Kubernetes', 'Azure', 'GCP'],
  content: `
Platform teams often rebuild the same cluster plumbing for every product. A GitOps landing zone flips that: the desired state lives in Git, and the cluster converges continuously.

![From manual cluster rebuilds to GitOps landing zones on AKS and GKE](${diagram})

## What belongs in the landing zone

- Cluster bootstrap (CNI, ingress, certs)
- Identity (Azure Workload Identity / GCP Workload Identity Federation)
- Secrets via External Secrets Operator
- Baseline policy and observability

## Flux + Kustomize pattern

Keep a thin base and environment overlays. Product teams consume a shared platform chart or Kustomize base; they never hand-edit live clusters.

\`\`\`bash
flux bootstrap github \\
  --owner=org \\
  --repository=fleet \\
  --path=clusters/prod-aks
\`\`\`

## Why this sticks

Declarative promotion, auditable drift, and the same mental model on AKS and GKE. The platform stays boring — in the best way.
`
};

export default post;
